import { noticeError } from '@ratehub/base-ui';

import TRAVEL_FEATURE_OPTIONS from '../definitions/TravelFeatureOptions';


/**
 * transform API slugs for card features into their localized message descriptors
 *
 * @param {string[]} features
 * @returns {id: string, defaultMessage: string}[]
 */
function getLocalizedTravelFeatures(features) {
    const localizedTravelFeatures = features
        .map(slug => TRAVEL_FEATURE_OPTIONS.find(option => option.value === slug)?.label)
        .filter(msg => msg);       // should not happen: fetched a slug we have no message for

    // unlikely, but let’s catch it should it happen
    if (features.length !== localizedTravelFeatures.length) {
        noticeError(new RangeError('getLocalizedTravelFeatures: at least one entry is not a valid travel feature option.'),
            { features: `'${features.join(', ')}'` },
        );
    }

    return localizedTravelFeatures;
}

export default getLocalizedTravelFeatures;
